import React from "react";

function LeftSection({
  imageUrl,
  productName,
  productDescription,
  tryDemo,
  learnMore,
  googlePlay,
  appStore,
}) {
  return (
    <div className="container mt-5 ">
      <div className="row ">
        <div className="col-6 p-5">
          <img src={imageUrl} alt={productName} className="img-fluid" />
        </div>
        <div className="col-6 p-5 mt-5">
          <h1>{productName}</h1>
          <p>{productDescription}</p>
          <div>
            <a href={tryDemo} className="btn btn-primary m-2 " style={{marginleft:"50px"}}>
              Try Demo
            </a>
            <a href={learnMore} className="btn btn-outline-primary m-2" style={{marginleft:"50px"}}>
              Learn More
            </a>
          </div>
          <div className="mt-3">
          <a href={googlePlay} className="btn btn-outline-primary m-2">
            <img src="media/googlePlayBadge.svg" alt="Google Play" />
          </a>
          <a href={appStore} className="btn btn-outline-primary m-2">
            <img src="media/appStoreBadge.svg" alt="App Store" />
          </a>
          </div>

        </div>
      </div>
    </div>
  );
}

export default LeftSection;
